/**
 * File: navIconsUtils.ts
 * Path: apps/admin/src/modules/layout/utils/navIconsUtils.ts
 * Description: Icons for the admin menu, looked up by the name each item
 * carries in packages/config's SIDEBAR_ITEMS. Used by the phone bottom bar
 * and the section pages.
 */

import {
  Activity,
  Bell,
  Home,
  FolderOpen,
  GraduationCap,
  Handshake,
  Users,
  Wrench,
  Settings,
  Briefcase,
  Package,
  Search,
  FileText,
  FileSignature,
  Palette,
  Share2,
  Sparkles,
  Star,
  HelpCircle,
  BookOpen,
  Wallet,
  Banknote,
  BarChart3,
  Repeat,
  ListTree,
  Scale,
  Landmark,
  Building2,
  SlidersHorizontal,
  type LucideIcon,
} from "lucide-react";

const NAV_ICONS: Record<string, LucideIcon> = {
  Activity,
  Bell,
  Home,
  FolderOpen,
  GraduationCap,
  Handshake,
  Users,
  Wrench,
  Settings,
  Briefcase,
  Package,
  Search,
  FileText,
  FileSignature,
  Palette,
  Share2,
  Sparkles,
  Star,
  BookOpen,
  Wallet,
  Banknote,
  BarChart3,
  Repeat,
  ListTree,
  Scale,
  Landmark,
  Building2,
  SlidersHorizontal,
  HelpCircle,
};

export const navIcon = (name?: string): LucideIcon =>
  (name ? NAV_ICONS[name] : undefined) ?? HelpCircle;
